import React from 'react'
import '../assets/css/style.css';
import '../style/HomeScreen.css'
const ContactUsUI = () => {
  return (
    <div className="amg-floating-contacts">
      <div className="amg-floating-contact-wrap">
        <div className="amg-floating-icon" title="Contact Us">
          <i className="ri-customer-service-2-line"></i>
        </div>
        <div className="amg-floating-link">
          {/* <!-- <h4>Contact Us</h4> --> */}
          <div className="row">


            <div className="col-md-12">
              <div>
                <h6>RBI Retail Direct Support</h6>
                <p>
                  <i className="ri-phone-line"></i>{" "}
                  <i
                    className="ri-arrow-right-up-line mx-1"
                    style={{ color: "limegreen", marginLeft: "-4px" }}
                  ></i>
                  <a href="tel:1800 267 7955" title="Out-Bound Number">
                    1800 267 7955
                  </a>
                </p>

                <p>
                  <i className="ri-phone-line"></i>{" "}
                  <i
                    className="ri-collapse-diagonal-line mx-1 inoutboundcontact"
                    style={{ marginLeft: "-4px", verticalAlign: "2px" }}
                  ></i>
                  <a
                    href="tel: +91-22-69385050"
                    title="In-Bound / Out-Bound Number"
                  >
                    +91-22-69385050
                  </a>
                </p>
                <p>
                  <i className="ri-phone-line"></i>{" "}
                  <i
                    className="ri-collapse-diagonal-line mx-1 inoutboundcontact"
                    style={{ marginLeft: "-4px", verticalAlign: "2px" }}
                  ></i>
                  <a
                    href="tel:+91-22-41075000"
                    title="In-Bound / Out-Bound Number"
                  >
                    +91-22-41075000
                  </a>
                </p>

                {/* <p>
                    <i className="ri-phone-line"></i>{" "}
                    <i className="ri-arrow-right-up-line" style={{ color: 'limegreen', marginLeft: '-4px' }}></i>
                    <a href="tel:1800 267  7955" title="Out-Bound Number">1800 267 7955</a>
                  </p>
                  <p>
                    <i className="ri-phone-line"></i>
                    <i className="ri-arrow-left-down-line" style={{ color: 'red', marginLeft: '-4px' }}>
                    </i>
                    <a href="tel:+91-22-61546335" title="In-Bound Number">+91-22-61546335</a>
                  </p> */}
                <p>
                  <i className="ri-mail-line"></i>{" "}
                  <a href="mailto:support@rbiretaildirect.org.in">
                    support@rbiretaildirect.org.in
                  </a>
                </p>
                <p>
                  <i className="ri-time-line"></i>{" "}
                  <a style={{ color: "#000" }}>
                    10am - 6pm (Monday - Saturday)
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>)
}; export default ContactUsUI 